import { render, staticRenderFns } from "./CardVideo.vue?vue&type=template&id=ab03338e&scoped=true&"
import script from "./CardVideo.vue?vue&type=script&lang=js&"
export * from "./CardVideo.vue?vue&type=script&lang=js&"
import style0 from "./CardVideo.vue?vue&type=style&index=0&id=ab03338e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab03338e",
  null
  
)

export default component.exports